import { first,  takeUntil, filter } from 'rxjs/operators';
import { Component, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { StreamService } from "../services";
import { Subject } from "rxjs";

@Component({
    styles: [`
        [mat-stretch-tabs] {
            display: flex;
            flex-basis: 0;
            flex-grow: 1;
        }
    `],
    template: `
        <div fxLayout="column">
            <div fxFlex="150px">
                <div fxFlex fxLayout="row" fxLayoutAlign="space-around center">
                    <a style="display: none" [routerLink]="['addSources']" routerLinkActive  #addSourcesRla="routerLinkActive"></a>
                    <nav mat-tab-nav-bar fxFlex>
                        <a mat-tab-link 
                           mat-stretch-tabs 
                           [routerLink]="['items/list']" 
                           routerLinkActive
                           #itemsRla="routerLinkActive" 
                           [active]="itemsRla.isActive">{{topic?.itemsCount}} Items</a>
                        <a mat-tab-link 
                           mat-stretch-tabs 
                           [routerLink]="['sources']" 
                           routerLinkActive
                           #sourcesRla="routerLinkActive" 
                           [active]="sourcesRla.isActive">{{topic?.subStreams.length}} Sources</a>
                        <a mat-tab-link 
                           mat-stretch-tabs 
                           [routerLink]="['filters']" 
                           routerLinkActive
                           #filtersRla="routerLinkActive" 
                           [active]="filtersRla.isActive">Filters</a>
                    </nav>
                </div>
            </div>
            <router-outlet></router-outlet>
        </div>
    `
})
export class EditTopicContentComponent implements OnDestroy {
    private cleanupTime = new Subject<void>();
    topic: any;

    constructor(route: ActivatedRoute, private streamService: StreamService) {
        route.parent.params
        .pipe(
            takeUntil(this.cleanupTime),
            filter((params: { topicId }) => params.topicId && (!this.topic || this.topic.id !== params.topicId))
        )
        .subscribe(params => this.fetchStream(params.topicId));
        streamService.streamUpdates.pipe(
            takeUntil(this.cleanupTime),
            filter(stream => stream && stream.id === route.snapshot.parent.params.topicId)
        ).subscribe(stream => this.fetchStream(stream.id));
    }

    fetchStream(topicId) {
        this.streamService.getStream(topicId, true).pipe(first()).subscribe(stream => this.topic = stream);
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
    }
}
